import { InputText } from 'primereact/inputtext'
import React from 'react'

export default function P211Search({data,goPage}) {
    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4" >
                <label htmlFor="">เลขที่สัญญา</label>
                <InputText 
                    type="text" placeholder="เลขที่สัญญา" 
                    value = {data.contractNo}
                    disabled
                />
            </div>
            <div className="p-field p-col-12 p-md-4" >
                <label htmlFor="">บริษัท</label>
                <InputText 
                    type="text" placeholder="บริษัท"
                    disabled
                    value = {data.contractorName}
                />
            </div>
            
            
        </div>
    )
}
